import styled from '@emotion/styled';
import { MOBILE_QRY } from '~/config';

export const HalfContainer = styled.div`
  width: 100%;

  ${MOBILE_QRY} {
    width: 50%;
    padding: 0;
  }

  &.no-padding {
    padding: 0;
  }
`;

export const ContentContainer = styled.div`
  display: none;

  ${MOBILE_QRY} {
    display: flex;
    width: 497px;
  }
`;
